import styled from 'styled-components';

export const CategoryOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  row-gap: 20px;
  p,
  h4 {
    margin: 0;
  }
`;

export const Input = styled.input`
  ${(props) => props.theme.newTypography.textStyleDisplayMedium};
  color: ${(props) => props.theme.newPalette.neutral.N800};
  border: none;
  word-break: break-word;
  min-width: 175px;
  width: 500px;

  &::placeholder {
    color: ${(props) => props.theme.newPalette.neutral.N600};
  }

  &:focus-visible {
    outline: none;
  }
`;
